'use strict'

function H4UiDate () {
  return {
    templateUrl: 'app/directives/h4UiDate/h4UiDate.html',
    restrict: 'AE',
    require: '?ngModel',
    scope: {
      ngModel: '=',
      form: '=',
      name: '@',
      label: '@',
      col: '@',
      required: '@',
      disabled: '=',
      placeholder: '@'
    },
    controller: function ($scope) {
      if (angular.isUndefined($scope.col)) $scope.col = '12'
    }
  }
}

angular.module('app').directive('h4UiDate', H4UiDate)



//////////////////
// WEBPACK FOOTER
// ./directives/h4UiDate/h4UiDate.directive.js
// module id = 88
// module chunks = 0